import { usePortalActiveClinic } from '@/lib/portalActiveClinic';
import { portalBookingHref } from '@/lib/portalBooking';

/** Booking URL for the patient's currently selected clinic, if online booking is enabled. */
export function usePortalBookingHref(): string | null {
  const { clinics, activeClinicId } = usePortalActiveClinic();
  const activeClinic = clinics.find((clinic) => clinic.clinic_id === activeClinicId);
  return portalBookingHref(activeClinic);
}
